export const useJobSiteSelectionModalStyles = () => {
  return {
    dialogPaper: {
      borderRadius: 1,
      maxHeight: '80vh'
    },
    dialogTitle: {
      padding: '24px 24px 16px 24px',
      borderBottom: 'none'
    },
    titleText: {
      fontFamily: 'Inter',
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '24px',
      color: '#29333d',
      textAlign: 'left' as const,
      marginBottom: '16px'
    },
    closeButton: {
      position: 'absolute' as const,
      right: 8,
      top: 8
    },
    dialogContent: {
      pt: 0
    },
    searchBox: {
      mb: 2
    },
    listContainer: {
      mb: 3,
      maxHeight: '300px',
      overflow: 'auto' as const,
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(0,0,0,0.05)'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,0.2)',
        borderRadius: '4px'
      }
    },
    loadingBox: {
      display: 'flex',
      justifyContent: 'center',
      py: 4
    },
    loadingText: {
      ml: 2,
      color: 'text.secondary'
    },
    emptyStateBox: {
      p: 3,
      textAlign: 'center' as const
    },
    emptyStateText: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      color: '#52667a'
    },
    list: {
      padding: 0,
      width: '100%',
      bgcolor: 'background.paper'
    },
    listItem: {
      padding: 0,
      width: '100%'
    },
    listItemButton: (isSelected: boolean, isLastItem: boolean) => ({
      backgroundColor: isSelected ? '#f2f8fd' : '#ffffff',
      borderBottom: isLastItem ? 'none' : '1px solid #e8ecf0',
      padding: '12px 16px',
      minHeight: 'auto',
      width: '100%',
      '&:hover': {
        backgroundColor: '#f2f8fd'
      },
      '&.Mui-selected': {
        backgroundColor: '#f2f8fd',
        '&:hover': {
          backgroundColor: '#f2f8fd'
        }
      }
    }),
    listItemPrimary: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      color: '#29333d',
      textAlign: 'left' as const
    },
    listItemSecondary: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      color: '#52667a',
      textAlign: 'left' as const
    },
    listItemText: {
      margin: 0,
      flex: 1
    },
    checkIcon: {
      color: '#016ad4',
      fontSize: '20px',
      marginLeft: '16px'
    },
    loadingMoreBox: {
      display: 'flex',
      justifyContent: 'center',
      py: 2
    },
    loadingMoreText: {
      ml: 2,
      color: 'text.secondary'
    },
    endOfListText: {
      textAlign: 'center' as const,
      py: 2,
      color: 'text.secondary',
      fontSize: '12px'
    },
    createJobSiteBox: {
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      alignSelf: 'stretch',
      px: 12,
      pb: 3
    },
    createJobSiteText: {
      textAlign: 'center' as const,
      color: '#29333D',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      mb: 1
    },
    actionButtonsBox: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: 2,
      borderTop: '1px solid #E8ECF0'
    },
    createOrderButton: {
      backgroundColor: '#016ad4',
      color: '#ffffff',
      borderRadius: '8px',
      padding: '12px 16px',
      marginTop: '24px',
      fontSize: '16px',
      fontWeight: 500,
      fontFamily: 'Inter, system-ui, sans-serif',
      textTransform: 'none' as const,
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#0056b3',
        boxShadow: 'none'
      },
      '&:disabled': {
        backgroundColor: '#e0e0e0',
        color: '#9e9e9e'
      }
    },
    repeatOrderButton: {
      borderColor: '#e0e7ff',
      backgroundColor: '#f8faff',
      color: '#016ad4',
      borderRadius: '8px',
      padding: '12px 16px',
      fontSize: '16px',
      fontWeight: 400,
      fontFamily: 'Inter, system-ui, sans-serif',
      textTransform: 'none' as const,
      '&:hover': {
        borderColor: '#016ad4',
        color: '#016ad4'
      },
      '&:disabled': {
        borderColor: '#e0e0e0',
        backgroundColor: '#f5f5f5',
        color: '#9e9e9e'
      }
    },
    createJobSiteButton: {
      borderColor: '#E8ECF0',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      padding: '8px 12px',
      fontSize: '16px',
      fontWeight: 400,
      fontFamily: 'Inter, system-ui, sans-serif',
      textTransform: 'none' as const,
      color: '#29333D',
      '&:hover': {
        borderColor: '#016ad4',
        color: '#016ad4',
        backgroundColor: '#f2f8fd',
        boxShadow: '0 2px 8px rgba(1, 106, 212, 0.15)'
      },
      '&:disabled': {
        borderColor: '#e0e0e0',
        backgroundColor: '#f5f5f5',
        color: '#9e9e9e'
      }
    },
    repeatOrderButtonContent: {
      display: 'flex',
      alignItems: 'center',
      gap: 1
    },
    repeatOrderIcon: {
      fontSize: '16px',
      flexShrink: 0
    },
    errorText: {
      color: '#da0901',
      fontFamily: 'Inter',
      fontSize: '12px',
      textAlign: 'center' as const,
      paddingBottom: '16px',
      mx: 7
    },
    repeatOrderNote: {
      textAlign: 'center' as const,
      color: 'text.secondary',
      fontSize: '14px',
      paddingBottom: '16px',
      mx: 7
    }
  }
}
